import { requestCourseVideoDetailPromise } from 'api/CourseVideo'
import React, { useMemo, useState } from 'react'
import Form from './form'

export default function BlacklistAdd (props) {
  const { id } = props.match.params
  const [data, setData] = useState({})
  const [mode, setMode] = useState('new')

  useMemo(() => {
    if (!id) return

    setMode('edit')
    requestCourseVideoDetailPromise(id).then(resp => {
      resp && setData(resp)
    })
  }, [id])

  return <Form mode={mode} data={data} setData={setData} {...props} />
}